import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'fileextension'})
export class FileExtensionChangePipe implements PipeTransform {
    transform(value: string, extension = 'jpg'): string {
        return value.replace(/\.\w+/, `.${extension}`);
    }

}
